import { celebrityInfo } from '@/mocks/site';

export default function CareerTimeline() {
  return (
    <section className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-[family-name:var(--font-heading)]">
            职业历程
          </h2>
          <p className="mt-2 text-sm text-foreground-500">Career Timeline</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
            {celebrityInfo.careerTimeline.map((item, index) => (
              <div
                key={item.year}
                className={`relative flex items-start gap-6 mb-8 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                <div className="hidden md:flex md:w-1/2"></div>
                <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 -translate-x-1.5 mt-1.5 z-10 ring-4 ring-background-100"></div>
                <div className={`ml-10 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pr-10' : 'md:pl-10'}`}>
                  <div className="p-4 rounded-lg bg-background-50 border border-background-200/70">
                    <span className="text-sm font-bold text-primary-500">{item.year}</span>
                    <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{item.event}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}